
const promoSlider = new Swiper(".promo-swiper", {
  slidesPerView: "auto",
  spaceBetween: 20,
  navigation: {
    nextEl: ".promo-swiper-swiper-button-next",
    prevEl: ".promo-swiper-swiper-button-prev",
  },
});
